module.exports = __webpack_public_path__ + "img/lookbook2.d6c233cb.jpg";